// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"1bfd9725","561":"ebf0a1cb","662":"14913ce2","788":"07119a5d","821":"a479e760","836":"a61e48e7","870":"8f860779"}[chunkId] + ".css";
};